import type { ReactNode } from 'react';

/**
 * Trust signal row: small icon + label. Subdued by default; tone="ember"
 * pulls the visual weight up.
 *
 *   <TrustBadge icon={<ShieldCheck size={16} />} label="Bar-verified" />
 *   <TrustBadge icon={<Clock size={16} />} label="Avg response 12 min" tone="ember" />
 */

export type TrustBadgeTone = 'ink' | 'ember' | 'sage';

export interface TrustBadgeProps {
    icon: ReactNode;
    label: string;
    tone?: TrustBadgeTone;
    className?: string;
}

const TONE_CLASSES: Record<TrustBadgeTone, string> = {
    ink: 'text-ink-soft',
    ember: 'text-ember-deep',
    sage: 'text-sage',
};

export function TrustBadge({
    icon,
    label,
    tone = 'ink',
    className,
}: TrustBadgeProps) {
    const cls = [
        'inline-flex items-center gap-1.5 text-[13px] font-medium',
        TONE_CLASSES[tone],
        className ?? '',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <span className={cls}>
            <span aria-hidden="true" className="inline-flex">
                {icon}
            </span>
            <span>{label}</span>
        </span>
    );
}

export default TrustBadge;
